import actions from './action.js';
import mutations from './mutations.js';
import getters from './getters.js';

const state = {
    routerName: '',
    loginStatus: false,
    userInfo: {},
    breadcrumbList: [],
    InnerHeight: 0,
    FullStatus: false,
};

export default {
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/navigation/index.js